import React from "react";
import { connect } from "react-redux";
import { getData, postData, deleteData, showToast } from "Source/globalFunction";
import Form from "./Form/Form";
import AddUser from "./Modal/AddUser/AddUser";
import DeleteUser from "./Modal/DeleteUser/DeleteUser";
import SectionLoader, { LOADER_POSITION, LOADER_TYPE } from "@/src/components/common/Elements/Spinner/SectionLoader/SectionLoader";

@connect(store => {
    return {
        project: store.project,
        global: store.global
    }
})

class Member extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedMember: {},
            selectedType: null,
            isUpdating: false,
            userType: null,
            showConfirmAddUserModal: true
        }
        _.map(["disregardChanges"], fn => {
            this[fn] = this[fn].bind(this);
        });
    }
    componentDidUpdate(prev){
        if(!_.isEqual(prev.isEdit, this.props.isEdit)){
            if(this.props.isEdit ==='members') {
                this.setState({ ...this.state, isUpdating: true });
            } else {
                this.disregardChanges()
            }
             
        }else if (!_.isEqual(prev.isOpen, this.props.isOpen)){
            const {hasChanges}=this.props
            if(prev.isOpen && prev.isOpen ==='members' && Object.keys(hasChanges)?.filter(f=>hasChanges[f]).length < 1) {
              this.setState({ ...this.state, isUpdating: false });
            }

        }
    }
     disregardChanges () {
        const { dispatch, project } = this.props;
        const safeMembers = Array.isArray(project.Selected.members) ? project.Selected.members.filter(m => !m.isNew).map(m => ({
            ...m,
            isRemoved: false,
            isInvited: false
        })) : [];
        this.setState({ ...this.state, isUpdating: false }, () => {
            dispatch({
                type: "SET_PROJECT_SELECTED", Selected: {
                    ...project.Selected,
                    members: safeMembers
                }
            });
            $("#membersDiscard").modal("hide");
            showToast("success", "Changes have been discarded");
        });
    }

    render() {
        const { dispatch, project } = this.props;

        const getInternalMembers = () => {
            const members = Array.isArray(project.Selected.members) ? project.Selected.members : [];
            return members.filter(m => m.user && String(m.user['user-type']).toLowerCase() === "internal");
        }

        const getExternalMembers = () => {
            const members = Array.isArray(project.Selected.members) ? project.Selected.members : [];
            return members.filter(m => m.user && String(m.user['user-type']).toLowerCase() === "external");
        }

        const users = [
            {title: "CloudCfo Users", type: "Internal", users: getInternalMembers()},
            {title: "Client Users", type: "External", users: getExternalMembers()},
        ];

         const handleSelectMember = (m) => {
            this.setState({...this.state, selectedMember: m}, () => {
                $("#remove-user").modal("show");
            });
        }

        // Per-row actions
        const handleAddMember = (type) => {
            this.setState({ selectedType: type }, () => {
                $("#addNewMemberModal").modal("show");
            });
        };

        // Add per-member logic for adding existing users
        const onAddExistingUser = async (member) => {
            if (!member || !member.id) return;
            const url = `api/projects/${project.Selected.id}/members`;
            const data = { "user-id": member.id };
            await postData(url, data, response => {
                if (response.status === 200) {
                    showToast("success", "Account member successfully added!");
                    onFetchUsers();
                }
                else {
                    if(response.status === 409){
                            showToast("error", "This username already exists.");
                    }
                    showToast("error", `There's a problem adding this member.`);
                }
            });
        }

        const handleRemoveMember = (member) => {
            this.setState({selectedMember: member}, () => {
                $("#remove-user").modal("show");
            });
        };

        // Update member in state after invite
        const handleInviteMember = (updatedMember) => {
            const members = Array.isArray(project.Selected.members) ? project.Selected.members : [];
            const newMembers = members.map(m =>
                m.id === updatedMember.id ? { ...m, ...updatedMember } : m
            );
            dispatch({
                type: "SET_PROJECT_SELECTED",
                Selected: {
                    ...project.Selected,
                    members: newMembers
                }
            });
        };

        const addExternalMember = async (data) => {
            const payload = {
                "first-name": data.firstName,
                "last-name": data.lastName,
                "username": data.username,
                "email-address": data.emailAddress,
                "role-id": data.userRole?.value,
                "contact-number": data.phoneNumber || "",
                "position": data.position || "",
                "company": data.supervisors || ""
            };

            const url = `api/projects/${project.Selected.id}/external-members`;
            this.setState({ isLoading: true });
            await postData(url, payload, response => {
                this.setState({ isLoading: false });
                if (response.status === 200) {
                    showToast("success", "Account member successfully added!");
                    this.setState({ showConfirmAddUserModal: true });
                    onFetchUsers();
                } else if(response.status === 409){
                    this.setState({ showConfirmAddUserModal: false });
                    showToast("error", `This username already exists.`);
                }
                else {
                    showToast("error", `There's a problem adding this member.`);
                    this.setState({ showConfirmAddUserModal: false });
                }
            });
        };

        const removeMember = async (member) => {
            const url = `api/project-members/${member.id}`;
            await deleteData(url, {}, response => {
                if (response) {
                    showToast("success", "The member has been removed from the project.");
                    onFetchUsers();
                }
            });
        };

        const onFetchUsers = async () => {
            const url = `api/projects/${project.Selected.id}/members`;
            await getData(url, {}, (response = {}) => {
                if(response) {
                    dispatch({type: "SET_PROJECT_SELECTED", Selected: {
                        ...project.Selected,
                        members: response.data || []
                    }});
                }
            });
        };

        return (
            <div class="memberFormsContainer" style={{ position: 'relative' }}>
                <div class="memberFormsHeader">
                    <div class="formHeaderTitle">
                        <h4>Members</h4>
                    </div>
                </div>
                <div class="memberFormsBody" style={{ minHeight: '200px', position: 'relative' }}>
                    {users.map((u, idx) => (
                        <Form 
                            key={u.type + '-' + idx} 
                            title={u.title} 
                            type={u.type}
                            members={u.users} 
                            onRemoveMember={handleRemoveMember}
                            onInviteMember={handleInviteMember}
                            onAddMember={() => handleAddMember(u.type)}
                        />
                    ))}
                    {this.state.isLoading && (
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            background: 'rgba(255,255,255,0.25)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 1000
                        }}>
                            <SectionLoader loaderPosition={LOADER_POSITION.absolute} loaderType={LOADER_TYPE.screen} />
                        </div>
                    )}
                </div>
                <AddUser 
                    project={project.Selected} 
                    selectedType={this.state.selectedType} 
                    members={this.state.selectedType === "External" ? getExternalMembers() : getInternalMembers()} 
                    onUserTypeChange={(userType) => {
                        this.setState({ userType });
                    }}
                    onAddMember={async (data) => {
                        if(this.state.selectedType === "Internal") {
                            await onAddExistingUser(data);
                        }
                        else if (this.state.selectedType === "External") {
                            if(this.state.userType === "new") {
                                await addExternalMember(data);
                            }
                            else if(this.state.userType === "existing") {
                                await onAddExistingUser(data);
                            }
                        } 
                    }}
                />
                <DeleteUser 
                    member={this.state.selectedMember} 
                    onRemove={() => removeMember(this.state.selectedMember)} 
                />
            </div>
        );
    }
}

export default Member;